import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { label } from "../../lib/format";
import { PageHeader, Td, Th } from "../../components/common/UI";

const NOTES = { email: "SMTP / transactional email", sms: "SMS gateway", ocr: "OCR engine for scanned archives", esignature: "Electronic signature provider", ai_search: "AI-assisted search over authorized documents" };

export default function Integrations() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/integrations").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const toggle = (r) => api.put(`/integrations/${r.id}`, { is_enabled: !r.is_enabled, config: r.config || {} }).then(load).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="fade-up">
      <PageHeader eyebrow="Administration" title="Integrations" subtitle="Adapters are prepared but no external credentials are configured. Secrets are set only as server environment variables, never here." />
      <div className="overflow-x-auto rounded-md border border-slate-200 bg-white shadow-sm">
        <table className="w-full" data-testid="integrations-table">
          <thead><tr><Th>Provider</Th><Th>Purpose</Th><Th>Status</Th><Th>Requested</Th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <Td className="font-medium">{label(r.provider)}</Td>
                <Td>{NOTES[r.provider]}</Td>
                <Td><span className="rounded bg-amber-50 px-1.5 py-0.5 text-[11px] text-amber-800" data-testid={`integration-status-${r.provider}`}>{label(r.status)}</span></Td>
                <Td><input type="checkbox" checked={r.is_enabled} onChange={() => toggle(r)} data-testid={`integration-toggle-${r.provider}`} /></Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-xs text-slate-500">In-app notifications are active. Document storage uses private object storage (configured). Email, SMS, OCR, e-signature and AI search remain pending credentials.</p>
    </div>
  );
}
